import 'sweetalert2/dist/sweetalert2.css';
export default require('sweetalert2');